import React from "react"
import { currentCompany, publicUrl } from "../../../constants"

const alt = "Worldline"
const src = `${publicUrl}/images/${currentCompany}/logo.png`

const Worldline = props => (
    <img
        {...props}
        className="appical"
        width="285"
        height="unset"
        alt={alt}
        src={src}
    />
)

export default Worldline
